module.exports = __webpack_public_path__ + "4fc7b9939c50bbcd6a473bbfd635fc82.pdf";